import {DceJsx, DceJsxRenderer} from "dce-jsx";
import {ToolbarItem} from "./ToolbarItem";

export class ToolbarGroup extends DceJsxRenderer{

    private items: ToolbarItem[] = [];

    constructor(items: ToolbarItem[]) {
        super();
        this.items = items;
    }

    render(): JSX.Element {
        return (
            <div className={"toolbar-group"}>
                {
                    this.items.map(i => {
                        return i.generateElement();
                    })
                }
            </div>
        );
    }

}